import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetPriceListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    startDateStart: string | undefined
    startDateEnd: string | undefined
    endDateStart: string | undefined
    endDateEnd: string | undefined
    selectedProductKind: CustomSingleSelectModel | undefined
    selectedPotType: CustomSingleSelectModel | undefined
    selectedCurrencyType: CustomSingleSelectModel | undefined
    selectedTypes: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetPriceListPagingAndFilterRequest: GetPriceListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    endDateEnd: undefined,
    endDateStart: undefined,
    startDateEnd: undefined,
    startDateStart: undefined,
    selectedProductKind: undefined,
    selectedPotType: undefined,
    selectedCurrencyType: undefined,
    selectedTypes: [],
    columnFilters: []
}